"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FooterLink = exports.Lower = exports.Column = exports.SocialLinks = exports.IconLink = exports.Subscribe = exports.Title = exports.Upper = exports.FooterWrapper = void 0;

var _theming = require("@storybook/theming");

var _designSystem = require("@storybook/design-system");

var _styles = require("../shared/styles");

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var inverseBorder = 'rgba(255, 255, 255, 0.1)';
var FooterWrapper = (0, _theming.styled)("footer", process.env.NODE_ENV === "production" ? {
  target: "e1qg8vs88"
} : {
  target: "e1qg8vs88",
  label: "FooterWrapper"
})("position:relative;z-index:10;background-color:", function (props) {
  return props.inverse ? '#0E0C2A' : _styles.background.app;
}, ";border-top:1px solid ", function (props) {
  return props.inverse ? inverseBorder : _styles.color.border;
}, ";padding-top:3rem;padding-bottom:3rem;@media (min-width: ", _styles.breakpoints[2], "px){padding-top:4rem;padding-bottom:4rem;}");
exports.FooterWrapper = FooterWrapper;
var Upper = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "e1qg8vs87"
} : {
  target: "e1qg8vs87",
  label: "Upper"
})(_styles.pageMargins, ";display:flex;flex-direction:column;align-items:flex-start;flex-wrap:wrap;@media (min-width: ", _styles.breakpoints[2], "px){flex-direction:row;align-items:flex-end;justify-content:space-between;}");
exports.Upper = Upper;
var Title = ( /*#__PURE__*/0, _theming.styled)(_designSystem.Subheading, process.env.NODE_ENV === "production" ? {
  target: "e1qg8vs86"
} : {
  target: "e1qg8vs86",
  label: "Title"
})(_styles.subheading.regular, ";line-height:20px;display:block;color:", _styles.color.mediumdark, ";margin-bottom:16px;");
exports.Title = Title;
var Subscribe = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "e1qg8vs85"
} : {
  target: "e1qg8vs85",
  label: "Subscribe"
})("flex:1 1 300px;min-width:0;display:flex;align-items:flex-start;flex-direction:column;form{margin-bottom:16px;}@media (min-width: ", _styles.breakpoints[1], "px){flex-direction:row;align-items:center;form{margin-bottom:0;margin-right:20px;}}@media (min-width: ", _styles.breakpoints[2], "px){margin-right:30px;}");
exports.Subscribe = Subscribe;
var IconLink = ( /*#__PURE__*/0, _theming.styled)(_designSystem.Button, process.env.NODE_ENV === "production" ? {
  target: "e1qg8vs84"
} : {
  target: "e1qg8vs84",
  label: "IconLink"
})("&:not(:last-child){margin-right:15px;}", function (props) {
  return props.appearance === 'inverseOutline' && "\n        box-shadow:(255, 255, 255, 0.1) 0 0 0 1px inset;\n        color: (255, 255, 255, 0.1);\n\n        &:hover {\n          box-shadow:(255, 255, 255, 0.1) 0 0 0 1px inset;\n          background: transparent;\n        }\n\n        &:active {\n          background: (255, 255, 255, 0.1);\n          box-shadow:(255, 255, 255, 0.1) 0 0 0 1px inset;\n          color: ".concat(_styles.color.darkest, ";\n        }\n    ");
}, ";");
exports.IconLink = IconLink;
IconLink.defaultProps = {
  isLink: true,
  containsIcon: true
};
var SocialLinks = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "e1qg8vs83"
} : {
  target: "e1qg8vs83",
  label: "SocialLinks"
})(process.env.NODE_ENV === "production" ? {
  name: "uo6iq7",
  styles: "flex:none;display:flex;align-items:center;margin-top:24px"
} : {
  name: "uo6iq7",
  styles: "flex:none;display:flex;align-items:center;margin-top:24px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
exports.SocialLinks = SocialLinks;
var Column = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "e1qg8vs82"
} : {
  target: "e1qg8vs82",
  label: "Column"
})(process.env.NODE_ENV === "production" ? {
  name: "5s2gg1",
  styles: ">a{line-height:20px;display:block;margin-bottom:12px;&:last-child{margin-bottom:0;}}"
} : {
  name: "5s2gg1",
  styles: ">a{line-height:20px;display:block;margin-bottom:12px;&:last-child{margin-bottom:0;}}",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
exports.Column = Column;
var Lower = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "e1qg8vs81"
} : {
  target: "e1qg8vs81",
  label: "Lower"
})(_styles.pageMargins, ";padding-top:3rem;display:grid;grid-template-columns:repeat(auto-fit, minmax(100%, 1fr));grid-column-gap:24px;grid-row-gap:32px;@media (min-width: ", _styles.breakpoints[1], "px){grid-template-columns:repeat(2, 1fr);}@media (min-width: ", _styles.breakpoints[2], "px){grid-template-columns:repeat(3, 1fr) max-content;padding-top:4rem;grid-row-gap:24px;}");
exports.Lower = Lower;
var FooterLink = ( /*#__PURE__*/0, _theming.styled)(_designSystem.Link, process.env.NODE_ENV === "production" ? {
  target: "e1qg8vs80"
} : {
  target: "e1qg8vs80",
  label: "FooterLink"
})("font-size:", _styles.typography.size.s2, "px;");
exports.FooterLink = FooterLink;
FooterLink.defaultProps = {
  tertiary: true
};